export interface IAidasAuthority {
  id?: number;
  name?: string;
}

export const defaultValue: Readonly<IAidasAuthority> = {};
